<script setup>
import { useI18n } from 'vue-i18n'
import DriverPortalLayout from '@/Layouts/DriverPortalLayout.vue'
import EarningsCard from '@/Components/DriverPortal/EarningsCard.vue'
import { Link } from '@inertiajs/vue3'
import { useCurrency } from '@/composables/useCurrency.js'

defineOptions({ layout: DriverPortalLayout })
const { t } = useI18n()
const { formatMoney } = useCurrency()

defineProps({
  earnings: {
    type: Object,
    required: true
  }
})
</script>

<template>
  <h1 class="title">{{ t('driver_portal.earnings.title') }}</h1>

  <EarningsCard :earnings="earnings" />

  <div v-if="earnings.unpaid_count > 0" class="unpaid-hint">
    <p>
      {{ t('driver_portal.earnings.unpaid_hint', { count: earnings.unpaid_count, amount: formatMoney(earnings.unpaid_cents) }) }}
    </p>
    <Link href="/payouts" class="link-btn">{{ t('driver_portal.earnings.view_payouts') }}</Link>
  </div>

  <div v-else class="all-paid">
    {{ t('driver_portal.earnings.all_paid') }}
  </div>
</template>

<style scoped>
.title { font-size: 1.5rem; font-weight: 700; margin: 0 0 1.25rem; color: var(--ink); }
.unpaid-hint {
  background: color-mix(in oklch, var(--warn) 8%, var(--surface));
  border: 1px solid color-mix(in oklch, var(--warn) 30%, var(--line));
  border-radius: 0.75rem;
  padding: 1rem 1.25rem;
  font-size: 0.9375rem;
  color: var(--ink);
}
.unpaid-hint p { margin: 0 0 0.75rem; }
.link-btn {
  display: inline-block;
  padding: 0.55rem 1rem;
  background: var(--accent);
  color: var(--accentInk);
  border-radius: var(--radius-button, 8px);
  font-weight: 600;
  font-size: 0.9375rem;
  text-decoration: none;
}
.all-paid {
  text-align: center;
  padding: 2.5rem 1rem;
  color: var(--muted);
  font-size: 0.9375rem;
}
</style>
